import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  rootContainer: {
    marginBottom: '110px',
  },
  imgGrid: {},
  midImgGrid: {
    transform: 'translateY(180px)',
    [theme.breakpoints.down('md')]: {
      transform: 'translateY(0px)',
    },
  },
  zenMidImgGrid: {
    transform: 'translateY(0px)',
  },
}))

export default useStyles
